import React from "react";

import ArrowRight from "images/icons/arrow-right.inline.svg";
import DownloadSvg from "images/icons/fi-rr-download.inline.svg";
import { Link } from "utils/customLink";

const TextHorizontalCard = ({
  imgSrc,
  title,
  desc,
  url,
  linkTitle = "Download",
  type = "download"
}) => {
  if (!title || !desc) return <></>;

  return (
    <div
      className={`flex flex-col md:flex-row drop-shadow-xl md:drop-shadow-none ${
        type === "download" ? " grow md:basis-0" : ""
      }`}
    >
      <div className="sm:gvi-program-card-box h-full flex flex-col md:flex-row overflow-hidden rounded-xs relative ">
        <div
          className={`md:w-[35%] md:bg-center bg-cover h-52 md:h-auto ${
            type === "author" ? "md:!w-1/4" : ""
          }`}
          style={{ backgroundImage: `url(${imgSrc})` }}
        />
        <div
          className={`flex flex-col justify-between md:w-[65%] py-6 md:py-9 px-6 ${
            type === "author"
              ? "md:!w-3/4 bg-white dark:bg-gray-darker md:px-14"
              : "bg-yellow-lighter dark:bg-gray-dark"
          }`}
        >
          <div>
            <h3
              className="text-xl pb-5 font-normal dark:font-semibold text-black-lighter dark:text-white"
              dangerouslySetInnerHTML={{ __html: title }}
            />
            <div
              className="pb-8 text-black-lighter dark:text-gray-generic"
              dangerouslySetInnerHTML={{ __html: desc }}
            />
          </div>

          {url && (
            <Link
              className={`callback-button group relative z-10 w-full md:w-7/12 flex py-2 gap-3 items-center justify-center ${
                type === "author" ? "md:!w-1/3" : ""
              }`}
              to={url}
              target={url?.startsWith("http") ? "gvi_blank" : ""}
            >
              <div
                className="font-bold"
                dangerouslySetInnerHTML={{ __html: linkTitle }}
              />
              {type === "download" && (
                <DownloadSvg className="w-5 pr-1 fill-black-lighter group-hover:fill-white dark:fill-white dark:group-hover:fill-gray-darker" />
              )}
              {type === "author" && (
                <ArrowRight className="w-3 h-3 stroke-black-lighter dark:stroke-white group-hover:stroke-white dark:group-hover:stroke-black-lighter" />
              )}
            </Link>
          )}

          {url && (
            <Link
              className="absolute left-0 top-0 right-0 bottom-0 z-0"
              to={url}
              target={url?.startsWith("http") ? "gvi_blank" : ""}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default TextHorizontalCard;
